export default Object.freeze({
  "360": "360",
  "365": "365"
});
